import { FaPython, FaReact, FaJs, FaBootstrap, FaVuejs, FaHtml5, FaCss3, FaGoogle, FaUnity } from 'react-icons/fa'
import { SiAdobephotoshop, SiPostgresql, SiSqlite, SiGoland, SiC, SiCplusplus, SiCsharp } from 'react-icons/si'
import { GrMysql } from 'react-icons/gr'

function StackArea() {
  
    return (

        <div className="stack-wrapper">
            <div className="row container-fluid">
                <h1 className="col-sm-5 stack-title">.Stack</h1>
            </div> 
            <div className="row container-fluid stack-area">
                <div className="col-lg-3 lang">
                    <h1 className="lang-title">Languages</h1>
                    <p className="lang-desc">
                        <button className="btn"><FaPython/>&nbsp;Python</button>
                        <button className="btn"><FaJs/>&nbsp;JavaScript</button>
                        <button className="btn"><FaHtml5/>&nbsp;HTML5</button>
                        <button className="btn"><FaCss3/>&nbsp;CSS3</button>
                        <button className="btn"><FaBootstrap/>&nbsp;Bootstrap</button>
                        <button className="btn"><FaReact/>&nbsp;React</button>
                        <button className="btn"><FaVuejs/>&nbsp;Vue</button>
                        <button className="btn"><SiC/>&nbsp;C</button>
                        <button className="btn"><SiCplusplus/>&nbsp;C++</button>
                        <button className="btn"><SiCsharp/>&nbsp;C#</button>
                        <button className="btn"><SiGoland/>&nbsp;Golang</button>
                    </p>
                </div>
                <div className="col-lg-3 database">
                    <h1 className="database-title">Databases</h1>
                    <p className="database-desc">
                    <button className="btn"><GrMysql/>&nbsp;MySQL</button>
                    <button className="btn"><SiPostgresql/>&nbsp;PostgresQL</button>
                    <button className="btn"><SiSqlite/>&nbsp;SQLite</button>
                    </p>
                </div>
                <div className="col-lg-3 tools">
                    <h1 className="tools-title">Tools</h1>
                    <p className="tools-desc">
                    <button className="btn"><FaUnity/>&nbsp;Unity</button>
                    <button className="btn"><FaGoogle/>&nbsp;Google Apps</button>
                    <button className="btn"><SiAdobephotoshop/>&nbsp;Adobe Photoshop</button>
                    </p>
                </div>
            </div>
         
        </div>

    )

}

export default StackArea;
